import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import { updateDivision, AddOrUpdateDivisionApiModel, DivisionModel } from "@tCentro/Services/CENAdminDivisionService";

export interface UpdateDivisionParameter extends HasOnSuccess<DivisionModel>, HasOnError<string> {
    model: AddOrUpdateDivisionApiModel;
}

type HandlerType = ApiHandler<UpdateDivisionParameter, { apiResult: DivisionModel }>;

export const UpdateDivision: HandlerType = async props => {
    try {
        const result = await updateDivision(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result as DivisionModel);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to update division");
        }
    }
};

export const chain = [UpdateDivision];
const updateDivisionData = createHandlerChainRunner(chain, "updateDivisionData");
export default updateDivisionData;
